export default __webpack_public_path__ + "static/services-detailsmdm-3626275f7578be15acf19a5ef86ace3a.jpg";